export default __webpack_public_path__ + "static/media/aped-email.3ad9d449.svg";